import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles/index.css";

/**
 * Entry point.
 *
 * A missing environment variable throws inside `App` on the first Firebase
 * access. The catch here turns that into a readable page instead of a white
 * screen with a console message nobody opens — and it names the variable,
 * because the person seeing it is the one who can fix it.
 */
const container = document.getElementById("root");
if (!container) throw new Error("[boot] #root is missing from index.html");

try {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
} catch (error) {
  container.textContent = String(error);
  throw error;
}
